import type { TelemetryValue } from "../types/telemetry";

export const STALE_TELEMETRY_MAX_AGE_MS = 30_000;

/** Age after which a live gauge metric is considered stale (feed dead). */
export const GAUGE_STALE_MS = 10_000;

const STALE_LIVE_TELEMETRY_METRICS = new Set([
  "car-pi/cpu_temp_c",
]);

/**
 * Generic staleness check: true when a telemetry value is older than
 * `maxAgeMs`. Used by live gauges and the status bar to signal a dead feed
 * instead of silently showing the last received value.
 */
export function isTelemetryStale(
  telemetry: TelemetryValue | undefined,
  now = Date.now(),
  maxAgeMs = GAUGE_STALE_MS,
): boolean {
  if (!telemetry) return false;
  return now - telemetry.timestamp > maxAgeMs;
}

export function isStaleLiveTelemetryMetric(
  metric: string,
  telemetry: TelemetryValue,
  now = Date.now(),
): boolean {
  return (
    STALE_LIVE_TELEMETRY_METRICS.has(metric) &&
    now - telemetry.timestamp > STALE_TELEMETRY_MAX_AGE_MS
  );
}

export function shouldExpireLiveTelemetryMetric(metric: string): boolean {
  return STALE_LIVE_TELEMETRY_METRICS.has(metric);
}
